import React from 'react';
import * as Bixby from '$/core';
import {
  FINANCIALS_CATEGORY,
  LENDER_PRESENTATIONS_CATEGORY,
  ORG_CHART_CATEGORY,
} from '$/components/company-documents-upload/categories';
import dayjs from 'dayjs';
import { ReactComponent as PlusIcon } from '$/assets/icons/plus.svg';
import { ReactComponent as XIcon } from '$/assets/icons/x-icon.svg';
import './index.scss';

const categoriesWithExtras = [FINANCIALS_CATEGORY, LENDER_PRESENTATIONS_CATEGORY];

const formatCompanyDocumentCompanyDocumentCategory = (cdcdc: Bixby.Models.CompanyDocumentCompanyDocumentCategory) => {
  if (
    categoriesWithExtras.includes(cdcdc.companyDocumentCategory_Id) &&
    cdcdc.financialDocumentType &&
    cdcdc.financialDocumentDate
  ) {
    return ` ${cdcdc.categoryName} (${cdcdc.financialDocumentType} - ${dayjs(cdcdc.financialDocumentDate).format(
      'MMM-YY'
    )})`;
  } else if (cdcdc.companyDocumentCategory_Id === ORG_CHART_CATEGORY && cdcdc.orgChartPageNumber) {
    return ` ${cdcdc.categoryName} (Page ${cdcdc.orgChartPageNumber})`;
  } else {
    return ` ${cdcdc.categoryName}`;
  }
};

interface IProps {
  documentId: string;
  companyDocumentCompanyDocumentCategories: Bixby.Models.CompanyDocumentCompanyDocumentCategory[] | undefined;
  isEditable: boolean;
  onEditCategory: (fileId: string) => void;
  onDeleteCategory: (newCategories: Bixby.Models.CompanyDocumentCompanyDocumentCategory[] | undefined) => void;
}

const CompanyDocumentsCategoryEditor: React.FC<IProps> = props => {
  const { documentId, companyDocumentCompanyDocumentCategories, isEditable, onEditCategory, onDeleteCategory } = props;
  if (isEditable) {
    if (companyDocumentCompanyDocumentCategories && companyDocumentCompanyDocumentCategories.length > 0) {
      return (
        <div className="edit-contain edit-contain-categories">
          <div>
            {companyDocumentCompanyDocumentCategories &&
              companyDocumentCompanyDocumentCategories.length > 0 &&
              companyDocumentCompanyDocumentCategories.map((cdcdc, index) => (
                <React.Fragment key={index}>
                  <div className="category">
                    {formatCompanyDocumentCompanyDocumentCategory(cdcdc)}
                    <button
                      onClick={() => {
                        companyDocumentCompanyDocumentCategories?.splice(index, 1);
                        onDeleteCategory(companyDocumentCompanyDocumentCategories);
                      }}
                      type="button">
                      <XIcon className="x-icon" role="presentation" />
                    </button>
                  </div>
                </React.Fragment>
              ))}
            <div />
            <button
              onClick={() => {
                onEditCategory(documentId);
              }}
              type="button">
              <div className="plus-contain">
                <PlusIcon />
                <div>Add</div>
              </div>
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="fake-link" role="button" onClick={() => onEditCategory(documentId)}>
          Configure
        </div>
      );
    }
  } else {
    return (
      <div>
        {companyDocumentCompanyDocumentCategories &&
          companyDocumentCompanyDocumentCategories.length > 0 &&
          companyDocumentCompanyDocumentCategories.map((cdcdc, index) => {
            return (
              <div key={index} className="category">
                {formatCompanyDocumentCompanyDocumentCategory(cdcdc)}
              </div>
            );
          })}
      </div>
    );
  }
};

export default CompanyDocumentsCategoryEditor;
